import React, { useEffect, useState } from 'react'
import { downloadCertificate, userEnrolledCourse } from '../../api/apiHandler'
import { formatDuration, isValidImageUrl } from '../../common/utilityFunctions';
import { Link } from 'react-router-dom';
import { encryption } from '../../common/enc_dec';
import { Loading } from '../../components/loading/loading';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18';

export const Test = () => {
    const { t } = useTranslation();

    const [courses, setCourses] = useState([]);
    const [activeTag, setActiveTag] = useState("ongoing");
    const [hasMounted, setHasMounted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');

    useEffect(() => {
        try {
            if (!hasMounted) setIsLoading(true);

            const fetchData = async () => {
                const response = await userEnrolledCourse({
                    is_random_test: true,
                    is_completed: activeTag === 'ongoing' || activeTag === 'completed',
                    is_test_completed: activeTag === 'completed',
                    page: pageToken,
                    limit: 6
                });
                if (response.code === 200 || response.code === 404) {
                    setCourses(response.data.data);
                    setTotalPage(response.data.paging);
                }
            }
            fetchData();
        }
        catch (err) {
            console.log('err: ', err);
        }
        finally {
            if (!hasMounted) setIsLoading(false);
            setHasMounted(true);
        }

    }, [activeTag])

    const handleDownloadCertificate = async (courseId) => {
        const certificateResponse = await downloadCertificate({
            course_id: courseId
        })
        if (certificateResponse.code === 200) {
            window.open(certificateResponse?.data?.certificate, '_blank');
        }
    }

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="course-single-area pd-top-120 pd-bottom-90">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="CartMainBox">
                            <h2 className="CartHeading">
                                {t('randomTestHeading')}
                            </h2>
                        </div>
                    </div>
                    <div className="col-12 RateAndReviewGride">
                        <div className="edmt-nav-tab style-white text-start">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a onClick={() => {
                                        setActiveTag("ongoing")
                                        setPageToken(1)
                                    }} className={`nav-link ${activeTag === "ongoing" && "active"}`} style={{ cursor: "pointer" }}>
                                        {t('onGoing')}
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a onClick={() => {
                                        setActiveTag("upcoming")
                                        setPageToken(1)
                                    }} className={`nav-link ${activeTag === "upcoming" && "active"}`} style={{ cursor: "pointer" }}>
                                        {t('upcoming')}
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a onClick={() => {
                                        setActiveTag("completed")
                                        setPageToken(1)
                                    }} className={`nav-link ${activeTag === "completed" && "active"}`} style={{ cursor: "pointer" }}>
                                        {t('completed')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div className="row">
                                {courses?.map((course) => (
                                    <div className="col-lg-4 col-md-6 CourseGride" key={course?.course_id}>
                                        <div className="single-course-inner">
                                            {/* <Link to={activeTag !== 'completed' && `/start-course/${encodeURIComponent(encryption({ course_id: course.course_id, category_id: course.user_course.category_id, language: course.user_course.language, is_test_completed: course.is_test_completed, is_completed: course.is_completed }, true))}`} className="thumb">
                                            </Link> */}
                                            <div className='thumb'>
                                                {/* <img src={course?.user_course?.image || process.env.PUBLIC_URL + "/assets/img/course/1.png"} alt="img" /> */}
                                                <img
                                                    src={
                                                        isValidImageUrl(course?.user_course?.image)
                                                            ? course?.user_course?.image
                                                            : `${process.env.PUBLIC_URL}/assets/img/other/course.jpg`
                                                    }
                                                    alt={course?.user_course?.name}
                                                />
                                            </div>
                                            <div className="details">
                                                {/* <Link to={activeTag !== 'completed' && `/start-course/${encodeURIComponent(encryption({ course_id: course.course_id, category_id: course.user_course.category_id, language: course.user_course.language, is_test_completed: course.is_test_completed, is_completed: course.is_completed }, true))}`} className="details-inner"> */}
                                                <div className='details-inner'>
                                                    <div className="d-flex justify-content-between mb-3">
                                                        <p className="CardMainHeading">
                                                            {course?.user_course?.course_category?.name}
                                                        </p>
                                                        {
                                                            course?.user_course?.assign_trainer && course?.user_course?.assign_trainer?.length > 0 && (
                                                                <div className="emt-user">
                                                                    <span className="u-thumb"><img src={course?.user_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="img" /></span>
                                                                    <span className="align-self-center">{course?.user_course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    <h6 className="CardMainSubHeading">{course?.user_course?.name}</h6>
                                                    <div className="LassonsMain">
                                                        <ul className="LassonsUl">
                                                            <li className="LassonsLi">
                                                                <p className="Lessonstext">
                                                                    {course?.user_course?.total_lession} {t('lessons')}
                                                                </p>
                                                            </li>
                                                            <li className="dots"></li>
                                                            <li className="LassonsLi">
                                                                <p className="Lessonstext">
                                                                    {formatDuration(course?.user_course?.duration, t)}
                                                                </p>
                                                            </li>
                                                            <li className="dots"></li>
                                                            <li className="LassonsLi">
                                                                <p className="Lessonstext">
                                                                    <strong>{course?.user_course?.validity}</strong> {t('daysValidity')}
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* </Link> */}
                                                <div className="emt-course-meta">
                                                    <div className="LassonsCardFooter">
                                                        <ul className="LassonsCardFooterUl">
                                                            <li className="LassonsCardFooterLi">
                                                                <div className="rating">
                                                                    <i className="fa fa-star"></i> {course?.user_course?.avg_review}
                                                                    <span>({course?.user_course?.total_review})</span>
                                                                </div>
                                                            </li>
                                                            <li className="LassonsCardFooterLi">
                                                                <div className="price">
                                                                    <span>₹{course?.user_course?.price}</span>
                                                                </div>
                                                            </li>
                                                            <li className="LassonsCardFooterLi">
                                                                {
                                                                    activeTag === 'ongoing' && (
                                                                        < Link to={`/start-test/${encodeURIComponent(encryption({ course_id: course?.course_id, course_name: course?.user_course?.name }, true))}`} className="StarttestLink">
                                                                            {t('startTest')}
                                                                        </Link>
                                                                    )
                                                                }
                                                                {
                                                                    activeTag === 'upcoming' && (
                                                                        < Link to={`/start-course/${encodeURIComponent(encryption({ course_id: course?.course_id, category_id: course?.user_course?.category_id, language: course?.user_course?.language, is_test_completed: course?.is_test_completed, is_completed: course?.is_completed }, true))}`} className="StarttestLink">
                                                                            {t('startCourse')}
                                                                        </Link>
                                                                    )
                                                                }
                                                                {
                                                                    activeTag === 'completed' && (
                                                                        course?.certificate != null && course?.certificate != undefined && (
                                                                            <button className="StarttestLink" onClick={() => handleDownloadCertificate(course?.course_id)}>
                                                                                {t('certificate')}
                                                                                <img
                                                                                    src={process.env.PUBLIC_URL + "/assets/img/icon/downloadCertificateicon.svg"}
                                                                                    alt="downloadCertificateicon"
                                                                                    className="downloadCertificateicon"
                                                                                />
                                                                            </button>
                                                                        )
                                                                    )
                                                                }
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {courses.length === 0 && (
                                    <h4 className='text-center mt-3 fw-light'>{t('noTestAvailable')}</h4>
                                )}
                                {courses && courses.length > 0 && (
                                    <ReactPaginate
                                        className='pagination mt-4'
                                        breakLabel="..."
                                        nextLabel={`${t('next')} >`}
                                        previousLabel={`< ${t('Previous')} `}
                                        renderOnZeroPageCount={null}
                                        onPageChange={handlePageClick}
                                        pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                                        forcePage={pageToken - 1}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}